export default function Footer() {
  return (
    <footer className="bg-[#F2F4F6] px-5 py-[30px] select-text">
      <div className="flex flex-col gap-[30px]">
        {/* 매장 정보 섹션 */}
        <div className="flex flex-col gap-2">
          <div className="flex gap-1">
            <h3 className="text-[#454545] text-sm font-semibold leading-[1.193359375em]">공세계</h3>
          </div>
          <div className="flex flex-col gap-[5px]">
            <p className="text-[#454545] text-sm font-normal leading-[1.193359375em]">
              경기 성남시 중원구 여수울로15번길 4-11 1층
            </p>
            <p className="text-[#454545] text-sm font-normal leading-[1.193359375em]">0507-1327-9542</p>
            <p className="text-[#454545] text-sm font-normal leading-[1.193359375em]">
              영업시간 평일 09:00-16:00, 주말 10:00-15:00
            </p>
            <p className="text-[#454545] text-sm font-normal leading-[1.193359375em]">매주 월/화 휴무</p>
          </div>
        </div>

        {/* 예약 주의사항 섹션 */}
        <div className="flex flex-col gap-2">
          <div className="flex gap-1">
            <h3 className="text-[#454545] text-sm font-semibold leading-[1.193359375em]">예약 주의사항</h3>
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex gap-1">
              <span className="text-[#454545] text-sm font-normal leading-[1.193359375em]">·</span>
              <p className="text-[#454545] text-sm font-normal leading-[1.193359375em] flex-1">
                예약 신청 후 1시간 내에 입금이 완료되어야 예약이 확정됩니다.
                <br />
                계좌번호 안내: 신한 110-449-763078 신현욱
              </p>
            </div>
            <div className="flex gap-1">
              <span className="text-[#454545] text-sm font-normal leading-[1.193359375em]">·</span>
              <p className="text-[#454545] text-sm font-normal leading-[1.193359375em] flex-1">
                메뉴별 예약 가능한 최대 주문 수량이 정해져 있습니다. 대량 구매를 원하실 경우 DM이나 전화로 사전에
                문의해주세요.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
